module.exports = __webpack_public_path__ + "img/usdc.117da43d.svg";